import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { Feature } from '@loyalty/shared-common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QlfPlaceholder } from '@qualifio/ui-commons';
import { colorPalette } from '@qualifio/ui-commons/src/theme/config/colors';
import { faBullseyePointer } from '@fortawesome/pro-solid-svg-icons/faBullseyePointer';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { useTranslation } from 'react-i18next';
import { IncomingWebhookForm } from './IncomingWebhookForm';
import { QlfPlaceholderIcon } from '../../../shared/qlf-placeholder-icon/QlfPlaceholderIcon';
import { useFeatures } from '../../../features/FeaturesContext';
import { useIncomingWebhooks } from '../../IncomingWebhookContext';

export function IncomingWebhookDetails(): React.ReactElement {
  const { t } = useTranslation();
  const { selectedWebhook, webhooks, createWebhook } = useIncomingWebhooks();
  const { features } = useFeatures();
  const { write: incomingWebhookWrite } = features[Feature.INCOMING_WEBHOOK];

  return webhooks.length === 0 || !selectedWebhook ? (
    <QlfPlaceholder
      icon={<QlfPlaceholderIcon icon={faBullseyePointer} color={colorPalette.grey.main} />}
      primaryText={t('incoming-webhooks.states.empty.title')}
      secondaryText={t('incoming-webhooks.states.empty.description')}
      actions={
        <Tooltip
          title={incomingWebhookWrite ? '' : t('shared.action.permission.required')}
          placement="left"
        >
          <div>
            <Button
              disabled={!incomingWebhookWrite}
              id={'empty-list-create-incoming-event'}
              color="primary"
              startIcon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createWebhook()}
              style={{ marginTop: '20px' }}
            >
              {t('incoming-webhooks.states.empty.create-action')}
            </Button>
          </div>
        </Tooltip>
      }
    />
  ) : (
    <IncomingWebhookForm key={selectedWebhook.id} webhook={selectedWebhook} />
  );
}
